export default __webpack_public_path__ + "static/media/sara.052e05aa.jpeg";